import React from 'react';

const Box = ({children,top}) => {

    return (
        <div className={`w-full  px-4 ${!top&&"lg:mt-[100px] mt-14"}`}>
            {children}
        </div>
    );
};

export default Box;